import { render, staticRenderFns } from "./report-irbo.vue?vue&type=template&id=e9e5f3f4&scoped=true&"
import script from "./report-irbo.vue?vue&type=script&lang=ts&"
export * from "./report-irbo.vue?vue&type=script&lang=ts&"
import style0 from "./report-irbo.vue?vue&type=style&index=0&id=e9e5f3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e5f3f4",
  null
  
)

export default component.exports